import { c as _c } from "react/compiler-runtime";
export default function CreateWaveInlineGroupHeader(t0) {
  const $ = _c(9);
  const {
    currentGroupLabel,
    unsavedGroupDescription,
    unsavedGroupSummary
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="tw-mb-1 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">Current group</p>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== currentGroupLabel) {
    t2 = <div className="tw-min-w-0 tw-rounded-lg tw-border tw-border-solid tw-border-white/5 tw-bg-iron-950/40 tw-p-3">{t1}<p className="tw-mb-0 tw-text-sm tw-font-semibold tw-text-iron-100">{currentGroupLabel}</p></div>;
    $[1] = currentGroupLabel;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== unsavedGroupDescription || $[4] !== unsavedGroupSummary) {
    t3 = unsavedGroupSummary && <div className="tw-min-w-0 tw-rounded-lg tw-border tw-border-solid tw-border-white/5 tw-bg-iron-950/40 tw-p-3"><p className="tw-mb-1 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">Unsaved group</p><p className="tw-mb-0 tw-text-sm tw-font-semibold tw-text-iron-100">{unsavedGroupSummary}</p>{unsavedGroupDescription && <p className="tw-mb-0 tw-mt-1 tw-text-xs tw-font-medium tw-text-iron-400">{unsavedGroupDescription}</p>}</div>;
    $[3] = unsavedGroupDescription;
    $[4] = unsavedGroupSummary;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="tw-flex tw-min-w-0 tw-flex-col tw-gap-3 md:tw-pr-[31rem]">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}